import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/event-log/filter-icon-green.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3d5bae5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container body-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Event Log", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filters-title-container" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Filters"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "date-and-time" }
const _hoisted_5 = { class: "date-time-select-from" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date-from" }, "From: ", -1))
const _hoisted_7 = { class: "date-time-select-to" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, "To: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "event-types-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Event type:", -1))
const _hoisted_12 = { class: "selected-event-types" }
const _hoisted_13 = { class: "clear-all-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "group-button-and-search-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copy", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CSV", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "search-container input-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "input-group-addon"
}, "Search:", -1))

import { computed, onBeforeMount, ref } from "vue";
import moment from "dayjs";
import axios from "axios";
import { debug as d } from "debug";
import { EventLogEntryApiModel } from "../../../api-models";
import EventLogTable from "../../../components/event-log/event-log-table.vue";
import EventTypePickerModal from "../../../components/event-log/event-type-picker-modal.vue";
import LoadingSpinner from "../../../components/loading-spinner.vue";
import { settleAll } from "../../../services/utilities/settle-all";
import JyreDatePicker from "../../../components/event-log/jyre-date-picker.vue";
import EventTypeBadge from "../../../components/event-log/event-type-badge.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'event-log',
  setup(__props) {

const debug = d("cs.EventLog");

const events = ref<EventLogEntryApiModel[]>([]);
const eventTypes = ref<string[]>([]);
const dateFrom = ref(moment().format("YYYY-MM-DD"));
const timeFrom = ref("00:00");
const dateTo = ref(moment().format("YYYY-MM-DD"));
const timeTo = ref(moment().format("HH:mm"));
const selectedEventTypes = ref<string[]>([]);
const searchInput = ref("");
const eventsAreLoading = ref(false);

// template refs
const PickerModal = ref<InstanceType<typeof EventTypePickerModal> | null>(null);

async function getEvents(): Promise<void> {
  eventsAreLoading.value = true;
  // Convert inputted dates/times to UTC before sending to the API
  const fromDateTimeUtc = moment(`${dateFrom.value} ${timeFrom.value}`, "YYYY-MM-DD HH:mm")
    .utc()
    .format("YYYY-MM-DD HH:mm");
  const toDateTimeUtc = moment(`${dateTo.value} ${timeTo.value}`, "YYYY-MM-DD HH:mm")
    .utc()
    .format("YYYY-MM-DD HH:mm");

  try {
    const res = await axios.get(
      `/api/admin/events?from=${fromDateTimeUtc}&to=${toDateTimeUtc}&includeTypes=${selectedEventTypes.value}`,
    );
    if (res.status === 200) {
      events.value = res.data.entries;
      eventsAreLoading.value = false;
    }
  } catch (e) {
    debug("/api/admin/events", e);
  }
}

async function getEventTypes(): Promise<void> {
  try {
    const res = await axios.get("/api/admin/eventtypes");
    if (res.status === 200) {
      eventTypes.value = res.data;
    }
  } catch (e) {
    debug("/api/admin/eventtypes", e);
  }
}

function clearSelectedEventTypes(): void {
  if (PickerModal.value === null) return;

  PickerModal.value.clearSelection();
  selectedEventTypes.value = [];
  getEvents();
}

function removeSelectedEventType(index: number): void {
  selectedEventTypes.value.splice(index, 1);
  getEvents();
}

function openModal(): void {
  if (PickerModal.value === null) return;
  PickerModal.value.openModal();
}

function includeSelectedEvents(selectedEvents: string[]): void {
  selectedEventTypes.value = selectedEvents;
  getEvents();
}

const searchFilteredEvents = computed(() => {
  if (searchInput.value === "") return events.value;
  return events.value.filter((event) =>
    JSON.stringify(event).toLowerCase().includes(searchInput.value),
  );
});

function getFormattedDate(timestamp: string): string {
  return moment(timestamp).format("D/M/YYYY H:mm:ss");
}

function getFormattedEvents(delimiter: string): string {
  const headers = [
    "Time",
    "Type",
    "Display Name",
    "Extra Properties",
    "Triggering user",
    "Users affected",
    "Groups affected",
  ];

  const formattedEvents = events.value.map((event) => {
    return [
      getFormattedDate(event.timestamp),
      event.type,
      event.displayName,
      event.extraProperties.length > 0
        ? event.extraProperties.map((p) => `${p.key}: ${p.value}`).join("; ")
        : "",
      event.triggeredByUser ? event.triggeredByUser.userEmail : "",
      event.usersAffected.length > 0 ? event.usersAffected.map((u) => u.userEmail).join("; ") : "",
      event.groupsAffected.length > 0
        ? event.groupsAffected.map((g) => g.groupName).join("; ")
        : "",
    ];
  });

  const tabSeperatedEvents = formattedEvents.map((event) => event.join(delimiter));
  tabSeperatedEvents.unshift(headers.join(delimiter));

  return tabSeperatedEvents.join("\r\n");
}

function copyEventLog(): void {
  const formattedEvents = getFormattedEvents("\t");
  window.navigator.clipboard.writeText(formattedEvents).then(() => {
    // eslint-disable-next-line no-alert
    alert(`Copied ${events.value.length} rows to clipboard`);
  });
}

function downloadCsvEventLog(): void {
  const csvContent = `data:text/csv;charset=utf-8,${getFormattedEvents(",")}`;
  const encodedUri = encodeURI(csvContent);

  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "Event Log - Jyre.csv");
  document.body.appendChild(link); // Required for FF
  link.click(); // This will download the data file
}

onBeforeMount(async () => {
  await settleAll([getEventTypes(), getEvents()]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EventTypePickerModal, {
      ref_key: "PickerModal",
      ref: PickerModal,
      "event-types": eventTypes.value,
      onAddSelectedEvents: includeSelectedEvents
    }, null, 8, ["event-types"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(JyreDatePicker, {
            modelValue: dateFrom.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateFrom).value = $event))
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            type: "time",
            class: "form-control",
            id: "date-from",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((timeFrom).value = $event))
          }, null, 512), [
            [_vModelText, timeFrom.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(JyreDatePicker, {
            modelValue: dateTo.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateTo).value = $event))
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            type: "time",
            class: "form-control",
            id: "date-to",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((timeTo).value = $event))
          }, null, 512), [
            [_vModelText, timeTo.value]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "apply-button-wrapper" }, [
        _createElementVNode("button", {
          class: "btn btn-primary apply-btn",
          onClick: getEvents,
          type: "button"
        }, "Apply")
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-default",
            onClick: openModal
          }, "Select...")
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEventTypes.value, (eventType, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(EventTypeBadge, {
                  "event-type-name": eventType,
                  onRemoveEventType: ($event: any) => (removeSelectedEventType(index))
                }, null, 8, ["event-type-name", "onRemoveEventType"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("a", {
          onClick: clearSelectedEventTypes,
          onKeydown: _withKeys(clearSelectedEventTypes, ["enter"]),
          tabindex: "0"
        }, "Clear all", 32)
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", { class: "dt-buttons btn-group" }, [
          _createElementVNode("button", {
            onClick: copyEventLog,
            class: "btn btn-default buttons-copy buttons-html5",
            tabindex: "0",
            "aria-controls": "logTable",
            href: "#",
            type: "button"
          }, _hoisted_17),
          _createElementVNode("button", {
            onClick: downloadCsvEventLog,
            class: "btn btn-default buttons-copy buttons-html5",
            tabindex: "0",
            "aria-controls": "logTable",
            href: "#",
            type: "button"
          }, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "search",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchInput).value = $event)),
            class: "form-control"
          }, null, 512), [
            [_vModelText, searchInput.value]
          ])
        ])
      ])
    ]),
    (!eventsAreLoading.value)
      ? (_openBlock(), _createBlock(EventLogTable, {
          key: 0,
          events: searchFilteredEvents.value
        }, null, 8, ["events"]))
      : (_openBlock(), _createBlock(LoadingSpinner, { key: 1 }))
  ]))
}
}

})